module.exports = __webpack_public_path__ + "images/hyundai_smallc40e2b943b8f7a0ba0022a4fb9591f86.png";